import { render, staticRenderFns } from "./ContentApplyDetail.vue?vue&type=template&id=83fff8c4&scoped=true&"
import script from "./ContentApplyDetail.vue?vue&type=script&lang=js&"
export * from "./ContentApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentApplyDetail.vue?vue&type=style&index=0&id=83fff8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fff8c4",
  null
  
)

export default component.exports